import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { Table, TD, TH, TR } from "@ag-media/react-pdf-table";

// Create styles
const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    padding: 20,
  },
  header: {
    fontSize: 16,
    textAlign: "center",
    marginBottom: 20,
  },
  section: {
    marginTop: 15,
    marginBottom: 15,
  },
  table: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
  },
  TR: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  TD: {
    borderRightWidth: 1,
    borderRightColor: "#000",
    borderRightStyle: "solid",
    padding: 5,
  },
  totalSection: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 20,
  },
  totalItem: {
    margin: 5,
    fontSize: 12,
    fontWeight: "bold",
  },
});

// Updated Invoice Data
const invoiceData = {
  remitTo:
    "Akamai Technologies International AG Grafenauweg 8 Zug CH-6300 Switzerland",
  taxIds: "Kenya VAT: P052208918D",
  invoiceTo: "Francis Wanjiku\n16057 Nairobi, Nairobi City, 00610 KE",
  invoiceNumber: "#23719201",
  invoiceDate: "March 1st, 2025",
  items: [
    {
      description: "Linode 2GB Valent Bookings (44352409)",
      from: "2023-04-04 21:21",
      to: "2023-04-25 21:41",
      quantity: 505,
      unitPrice: 0.018,
      amount: 10,
      taxRate: 16,
    },
    {
      description: "Objects Storage 500GB",
      from: "2023-04-01 07:00",
      to: "2023-04-04 21:21",
      quantity: 1,
      unitPrice: 5,
      amount: 5,
      taxRate: 16,
    },
  ],
  contactInfo:
    "Grafenauweg 8, Zug CH-6300 Switzerland\nP: 855-4-LINODE (855-454-6633)\nF: 609-380-7200\nW: https://www.linode.com",
};

// Calculate Tax and Total
const calculateTaxAndTotal = (items) => {
  const subtotal = items.reduce((acc, item) => acc + item.amount, 0);
  const tax = items.reduce(
    (acc, item) => acc + (item.amount * item.taxRate) / 100,
    0
  );
  const total = subtotal + tax;
  return { subtotal, tax, total };
};

const { subtotal, tax, total } = calculateTaxAndTotal(invoiceData.items);

// Invoice Component
const AkamaiInvoice = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <Text style={styles.header}>INVOICE</Text>

      {/* Invoice Details */}
      <View style={styles.section}>
        <Text>Invoice Date: {invoiceData.invoiceDate}</Text>
        <Text>Remit To: {invoiceData.remitTo}</Text>
        <Text>Tax ID(s): {invoiceData.taxIds}</Text>
        <Text>Invoice To: {invoiceData.invoiceTo}</Text>
        <Text>Invoice #: {invoiceData.invoiceNumber}</Text>
      </View>

      {/* Table */}
      <View style={styles.section}>
        <Table>
          <TH>
            <TD>
              <Text>Description</Text>
            </TD>
            <TD>
              <Text>From</Text>
            </TD>
            <TD>
              <Text>To</Text>
            </TD>
            <TD>
              <Text>Quantity</Text>
            </TD>
            <TD>
              <Text>Unit Price</Text>
            </TD>
            <TD>
              <Text>Amount</Text>
            </TD>
            <TD>
              <Text>Tax</Text>
            </TD>
            <TD>
              <Text>Total</Text>
            </TD>
          </TH>
          {invoiceData.items.map((item, index) => (
            <TR key={index}>
              <TD>
                <Text>{item.description}</Text>
              </TD>
              <TD>
                <Text>{item.from}</Text>
              </TD>
              <TD>
                <Text>{item.to}</Text>
              </TD>
              <TD>
                <Text>{item.quantity}</Text>
              </TD>
              <TD>
                <Text>${item.unitPrice.toFixed(2)}</Text>
              </TD>
              <TD>
                <Text>${item.amount.toFixed(2)}</Text>
              </TD>
              <TD>
                <Text>${((item.amount * item.taxRate) / 100).toFixed(2)}</Text>
              </TD>
              <TD>
                <Text>
                  $
                  {(item.amount + (item.amount * item.taxRate) / 100).toFixed(
                    2
                  )}
                </Text>
              </TD>
            </TR>
          ))}
        </Table>
      </View>

      {/* Totals Section */}
      <View style={styles.totalSection}>
        <View>
          <Text style={styles.totalItem}>
            Subtotal (USD): ${subtotal.toFixed(2)}
          </Text>
          <Text style={styles.totalItem}>Tax (16%): ${tax.toFixed(2)}</Text>
          <Text style={styles.totalItem}>Total (USD): ${total.toFixed(2)}</Text>
        </View>
      </View>

      {/* Contact Information */}
      <View style={styles.section}>
        <Text>{invoiceData.contactInfo}</Text>
      </View>

      {/* Note */}
      <View style={styles.section}>
        <Text>
          This invoice includes services that may have been powered off. If you
          no longer need these services, you can remove them from your account.
        </Text>
      </View>
    </Page>
  </Document>
);

export default AkamaiInvoice;
